import React, { useState } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { SNOOZE_OPTIONS } from '../../data/workOrderStarLabels';

const MENU_ITEM_CLASS =
	'bodyregular flex cursor-pointer items-center justify-between px-3 py-[5px] text-character-primary hover:bg-grey-3';

interface SnoozeOptionListProps {
	onSnooze: (minutes: number) => void;
	onCustom: () => void;
}

// "Remind me in: 15 minutes / 1 hour / 4 hours / 1 day / Custom"
export const SnoozeOptionList: React.FC<SnoozeOptionListProps> = ({ onSnooze, onCustom }) => (
	<div className="flex min-w-[160px] flex-col py-1">
		<span className="bodyregular px-3 py-[5px] text-character-secondary">Remind me in:</span>
		{SNOOZE_OPTIONS.map((option) => (
			<span
				key={option.minutes}
				role="menuitem"
				className={MENU_ITEM_CLASS}
				onClick={() => onSnooze(option.minutes)}
			>
				{option.label}
			</span>
		))}
		<span role="menuitem" className={MENU_ITEM_CLASS} onClick={onCustom}>
			Custom
		</span>
	</div>
);

interface ReminderMenuProps extends SnoozeOptionListProps {
	onStop: () => void;
	// Snoozing sets a new reminder time, so it's Pro-only like adding one; Stop is always offered.
	canSnooze?: boolean;
}

// Shown from the pill's dropdown once a reminder is due: stop it, or snooze it.
const ReminderMenu: React.FC<ReminderMenuProps> = ({
	onStop,
	onSnooze,
	onCustom,
	canSnooze = true,
}) => {
	const [showSnoozeOptions, setShowSnoozeOptions] = useState(false);

	if (showSnoozeOptions) {
		return <SnoozeOptionList onSnooze={onSnooze} onCustom={onCustom} />;
	}
	return (
		<div className="flex min-w-[160px] flex-col py-1">
			<span role="menuitem" className={MENU_ITEM_CLASS} onClick={onStop}>
				Stop
			</span>
			{canSnooze ? (
				<span
					role="menuitem"
					className={MENU_ITEM_CLASS}
					onClick={() => setShowSnoozeOptions(true)}
				>
					Snooze
					<RightOutlined className="text-xs text-character-secondary" />
				</span>
			) : null}
		</div>
	);
};

export default ReminderMenu;
